import client from './client';
import { getCache, setCache } from '../utils/apiCache';

export interface Settings {
    site_name: string;
    footer_description: string;
    contact_phone: string;
    contact_email: string;
    contact_address: string;
    whatsapp_number: string;
    whatsapp_message_fr: string;
    whatsapp_message_ar: string;
    social_facebook: string;
    social_instagram: string;
    facebook_pixel_id?: string;
    hero_title_ar?: string;
    hero_title_fr?: string;
    hero_subtitle_ar?: string;
    hero_subtitle_fr?: string;
    hero_badge_ar?: string;
    hero_badge_fr?: string;
    hero_image?: string;
    hero_organic_text_ar?: string;
    hero_organic_text_fr?: string;
    hero_quality_text_ar?: string;
    hero_quality_text_fr?: string;
    hero_customers_text_ar?: string;
    hero_customers_text_fr?: string;
}

export const fetchSettings = async (): Promise<Settings> => {
    const cacheKey = 'site_settings';
    const cachedData = getCache<Settings>(cacheKey);
    if (cachedData) return cachedData;

    const response = await client.get<Settings>('/settings');
    setCache(cacheKey, response.data);
    return response.data;
};
